// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  userTokenStore: "utknz",
  googleAuthClientid: "1077531527699-oe6251e7ghpsr00v4t6ntdumjm4j4loi.apps.googleusercontent.com",
  googleCredVariableName: "GoogleCredentials",
  //domainUrl: "http://localhost:4200",
  apiurl: 'https://api.prephub.io/api/',
  domains: {
    'unilagprep.prephub.io': {
      appName: 'University of Lagos Practice POST UTME Questions',
      sideBarLogo: '/assets/img/angular2-logo-white.png',
      landingPageLogo: '../../assets/assets/images/preplanding.svg',
      hamburger: '../../assets/assets/images/hamburger.svg',
      data: {
        landingpage: {
          firstsection: {
            text1: `Everything you need to `,
            text2: `pass `,
            text3: `your exams`,
            bulletpoints: [
              '  Practice exam questions.',
              '  Track your progress.',
              '  Instant feedback on performance.'
            ],
            image1: `../../assets/assets/images/Frame.svg`,
            image2: `../../assets/assets/images/studentimg.svg`
          },
          secondsection:{
            header: "Featured Practice Subjects"
          },
          showexclusiveplanprice: false,
          showcontactus: true
        },
        plans: [
          {
            id: 1,
            title: 'Basic',
            attempts: '5',
            price: '2,000',
            validity: '14 days',
            text: "Get started with our 'Basic' plan at just ₦2000. You'll have 5 attempts to explore the features for a valid period of 14 days - a simple and budget-friendly choice.",
            currency: '₦',
            iconpath: '../../assets/assets/images/planicon.svg'
          },
          {
            id: 2,
            title: 'Standard',
            attempts: '10',
            price: '3,500',
            validity: '30 days',
            text: "Upgrade to our 'Standard' plan for ₦3500. Enjoy 10 attempts over a 14-day period, providing you with a balanced and affordable solution for your needs.",
            currency: '₦',
            iconpath: '../../assets/assets/images/planicon2.svg'
          },
          {
            id: 3,
            title: 'Deluxe',
            attempts: '50',
            price: '10,000',
            validity: '120 days',
            text: `Upgrade to our 'Deluxe' package for just ₦10,000. Enjoy 50 attempts over 14 days, making it an affordable and convenient choice for your needs.`,
            currency: '₦',
            iconpath: '../../assets/assets/images/planicon3.svg'
          }
        ],
        exclusiveplans: [
          {
            id: 4,
            title: 'Commercial',
            attempts: 'Unlimited',
            price: '200,000',
            validity: '365 days',
            text: "Dive into endless possibilities with our 'Unlimited' plan, offering you an infinite number of attempts for just ₦200,000. Enjoy the freedom to explore our services for a full 30 days - because limitless potential shouldn't come with a limit on time.",
            currency: '₦',
            iconpath: '../../assets/assets/images/planicon4.svg'
          }
        ]
      },
      style: {
        color: `color: #3A14A8`,
        btnstyle: `
            border-color: none;
            border: solid;
            border-radius: 7px;
            color: #fff;
            background-color: #3A14A8;
            font-weight: normal;
            padding: 1.5rem 2.5rem;`,
        disabledbtnstyle: `
            border-color: #7165ff !important;
            color: #fff !important;
            background-color: grey !important;
            font-weight: normal !important;
            border-radius: 5px !important;`,
        plansiconcolor: 'text-primary',
        sidebarcolor: 'blue',
        landingpage: {
          firstsection: `
                height: 60vh; 
                background: linear-gradient(135deg, #E0E7FF 0%, #FFFFFF 40%, #FFFFFF 60%, #EDE9FE 100%);`,
          },
          gaugestyle: `
                height: 5px;
                background-color: #3A14A8;`
      }
    },
    'unilagfoundation.prephub.io': {
      appName: 'School of Foundation Studies Practice Questions',
      sideBarLogo: '/assets/img/angular2-logo-white.png',
      landingPageLogo: '../../assets/assets/images/preplanding.svg',
      hamburger: '../../assets/assets/images/hamburger.svg',
      data: {
        landingpage: {
          firstsection: {
            text1: `Everything you need to `,
            text2: `pass `,
            text3: `your exams`,
            bulletpoints: [
              '  Practice exam questions.',
              '  Track your progress.',
              '  Instant feedback on performance.'
            ],
            image1: `../../assets/assets/images/Frame.svg`,
            image2: `../../assets/assets/images/studentimg.svg`
          },
          secondsection:{
            header: "Featured Practice Subjects"
          },
          showexclusiveplanprice: false,
          showcontactus: false
        },
        plans: [        
          {
            id: 2,
            title: 'Premium',
            attempts: '2',
            price: '2,000',
            validity: '30 days',
            text: "Upgrade to our Premium plan for ₦2000. Enjoy 3 attempts over a 2-day period, providing you with a balanced and affordable solution for your needs.",
            currency: '₦',
            iconpath: '../../assets/assets/images/planicon2.svg'
          }
        ]       
      },
      style: {
        color: `color: #3A14A8`,
        btnstyle: `
            border-color: none;
            border: solid;
            border-radius: 7px;
            color: #fff;
            background-color: #3A14A8;
            font-weight: normal;
            padding: 1.5rem 2.5rem;`,
        disabledbtnstyle: `
            border-color: #7165ff !important;
            color: #fff !important;
            background-color: grey !important;
            font-weight: normal !important;
            border-radius: 5px !important;`,
        plansiconcolor: 'text-primary',
        sidebarcolor: 'blue',
        landingpage: {
          firstsection: `
                height: 60vh; 
                background: linear-gradient(135deg, #E0E7FF 0%, #FFFFFF 40%, #FFFFFF 60%, #EDE9FE 100%);`,
          },
          gaugestyle: `
                height: 5px;
                background-color: #3A14A8;`
      }
    }
  }
};
